document.addEventListener('DOMContentLoaded', function() {
    const togglerItems = document.querySelectorAll('.search-results-section__toggler-item');
    const sections = document.querySelectorAll('.search-results-section__body');

    togglerItems.forEach(toggler => {
        toggler.addEventListener('click', function() {
            togglerItems.forEach(item => item.classList.remove('active'));
            toggler.classList.add('active');

            const target = toggler.getAttribute('data-target');

            sections.forEach(section => {
                if (section.getAttribute('data-item') === target) {
                    section.classList.add('active');
                } else {
                    section.classList.remove('active');
                }
            });
        });
    });
});
